
export enum AlternativeNameTypeEnum {
    Investor = 1,
    AssetManger = 2,
    Fund = 3,
  }